<div class="historial-wrap p-3 sm:p-5 xl:p-8">

  <!-- ═══ Encabezado ═══ -->
  <div class="flex flex-wrap items-start justify-between gap-3 mb-4">
    <div class="min-w-0">
      <h1 class="titulo">Historial de operaciones</h1>
      <p class="subtitulo">
        Todos los rieles en una sola lista, de la más reciente a la más antigua.
        <span *ngIf="periodoReal">
          Período: <strong>{{ periodoReal.desde }}</strong> a <strong>{{ periodoReal.hasta }}</strong>
          <span class="text-gray-400"> (hora de Santiago)</span>
        </span>
      </p>
    </div>

    <div class="flex items-center gap-2 shrink-0">
      <button type="button" class="btn-secundario" (click)="recargar()" [disabled]="cargando">
        <mat-icon class="icono">refresh</mat-icon>
        <span class="hidden sm:inline">Actualizar</span>
      </button>
      <button type="button" class="btn-secundario" (click)="descargar('csv')"
        [disabled]="!!descargando || total === 0">
        <mat-icon class="icono">description</mat-icon>
        <span>{{ descargando === 'csv' ? 'Generando…' : 'CSV' }}</span>
      </button>
      <button type="button" class="btn-primario" (click)="descargar('xlsx')"
        [disabled]="!!descargando || total === 0">
        <mat-icon class="icono">table_view</mat-icon>
        <span>{{ descargando === 'xlsx' ? 'Generando…' : 'Excel' }}</span>
      </button>
    </div>
  </div>

  <!-- ═══ Aviso: se entró desde una tarjeta del tablero ═══ -->
  <div *ngIf="vieneDelTablero" class="aviso aviso-info mb-4">
    <mat-icon class="icono">info</mat-icon>
    <div class="min-w-0">
      <p class="m-0">
        Estás viendo con el <strong>mismo criterio del tablero</strong>: solo operaciones
        completadas, fechadas por su cierre. Lo rechazado, lo anulado y lo que quedó a
        medias ese día no aparece acá.
      </p>
      <button type="button" class="enlace" (click)="verTodoElMovimiento()">
        Ver todo el movimiento del período
      </button>
    </div>
  </div>

  <!-- ═══ Aviso: el backend recortó el período ═══ -->
  <div *ngIf="periodoRecortado" class="aviso aviso-alerta mb-4">
    <mat-icon class="icono">warning</mat-icon>
    <p class="m-0">
      El período pedido era muy largo y se recortó a
      <strong>{{ periodoReal?.desde }} — {{ periodoReal?.hasta }}</strong>.
      Para ver más atrás, consultá por tramos.
    </p>
  </div>

  <!-- ═══ Filtros ═══ -->
  <div class="tarjeta mb-4">
    <button type="button" class="cabecera-filtros lg:cursor-default"
      (click)="filtrosAbiertos = !filtrosAbiertos">
      <span class="flex items-center gap-2 min-w-0">
        <mat-icon class="icono text-gray-500">tune</mat-icon>
        <span class="font-semibold text-sm">Filtros</span>
        <span *ngIf="filtrosActivos" class="badge">{{ filtrosActivos }}</span>
      </span>
      <mat-icon class="icono lg:hidden text-gray-400"
        [style.transform]="filtrosAbiertos ? 'rotate(180deg)' : 'rotate(0)'">
        expand_more
      </mat-icon>
    </button>

    <div class="cuerpo-filtros" [class.hidden]="!filtrosAbiertos" [class.lg:block]="true">

      <!-- Atajos de período -->
      <div class="flex flex-wrap gap-2 mb-3">
        <button type="button" class="chip-atajo" (click)="ultimosDias(1)">Hoy</button>
        <button type="button" class="chip-atajo" (click)="ayer()">Ayer</button>
        <button type="button" class="chip-atajo" (click)="ultimosDias(7)">7 días</button>
        <button type="button" class="chip-atajo" (click)="ultimosDias(30)">30 días</button>
        <button type="button" class="chip-atajo" (click)="soloRechazadas()">Rechazadas</button>
        <button type="button" class="chip-atajo" (click)="soloEnProceso()">En proceso</button>
        <button type="button" class="chip-atajo chip-limpiar" (click)="limpiar()">
          <mat-icon class="icono-mini">close</mat-icon> Limpiar
        </button>
      </div>

      <!-- Campos. Una columna en el celular, dos en tablet, cuatro en escritorio. -->
      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-x-3">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Desde</mat-label>
          <input matInput type="date" [(ngModel)]="filtros.desde" (change)="aplicar()" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Hasta</mat-label>
          <input matInput type="date" [(ngModel)]="filtros.hasta" (change)="aplicar()" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full sm:col-span-2">
          <mat-label>Cliente</mat-label>
          <mat-icon matPrefix class="text-gray-400">search</mat-icon>
          <input matInput type="search" placeholder="Email, nombre, documento o ID"
            [(ngModel)]="filtros.usuario" (ngModelChange)="alEscribir()" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Operación</mat-label>
          <mat-select multiple [(ngModel)]="filtros.grupos" (selectionChange)="aplicar()">
            <mat-option *ngFor="let g of catalogos.grupos" [value]="g">
              {{ etiquetaGrupo(g) }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Estado</mat-label>
          <mat-select multiple [(ngModel)]="filtros.estados" (selectionChange)="aplicar()">
            <mat-option *ngFor="let e of catalogos.estados" [value]="e">{{ e }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Origen del dato</mat-label>
          <mat-select multiple [(ngModel)]="filtros.fuentes" (selectionChange)="aplicar()">
            <mat-option *ngFor="let f of catalogos.fuentes" [value]="f">
              {{ etiquetaFuente(f) }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Moneda</mat-label>
          <mat-select [(ngModel)]="filtros.moneda" (selectionChange)="aplicar()">
            <mat-option [value]="''">Todas</mat-option>
            <mat-option *ngFor="let m of catalogos.monedas" [value]="m">{{ m }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Tipo</mat-label>
          <mat-select multiple [(ngModel)]="filtros.tipos" (selectionChange)="aplicar()">
            <mat-option *ngFor="let t of catalogos.tipos" [value]="t">{{ t }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Operador</mat-label>
          <input matInput type="search" placeholder="Email del operador"
            [(ngModel)]="filtros.operador" (ngModelChange)="alEscribir()" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Fechar por</mat-label>
          <mat-select [(ngModel)]="filtros.baseFecha" (selectionChange)="aplicar()">
            <mat-option value="movimiento">Movimiento (todo)</mat-option>
            <mat-option value="termino">Cierre (criterio del tablero)</mat-option>
          </mat-select>
          <mat-hint *ngIf="filtros.baseFecha === 'termino'">
            Deja fuera lo que no tiene cierre
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Orden</mat-label>
          <mat-select [(ngModel)]="filtros.orden" (selectionChange)="aplicar()">
            <mat-option value="desc">Más reciente primero</mat-option>
            <mat-option value="asc">Más antigua primero</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- ═══ Totales del resultado filtrado (todas las páginas) ═══ -->
  <div *ngIf="resumen && !cargando && !error" class="totales mb-3">
    <div class="total">
      <span class="total-titulo">Cargas de saldo</span>
      <strong class="total-monto text-green-700">{{ montoClp(resumen.cargas.monto) }}</strong>
      <span class="total-pie">{{ cantidad(resumen.cargas.cantidad) }} cargas</span>
    </div>
    <div class="total">
      <span class="total-titulo">Envíos y retiros</span>
      <strong class="total-monto">{{ montoClp(resumen.salidas.monto) }}</strong>
      <span class="total-pie">{{ cantidad(resumen.salidas.cantidad) }} completados · CLP</span>
    </div>
    <div class="total">
      <span class="total-titulo">Rechazadas</span>
      <strong class="total-monto">{{ montoClp(resumen.rechazadas.monto) }}</strong>
      <span class="total-pie">
        {{ cantidad(resumen.rechazadas.cantidad) }} rechazadas
        <ng-container *ngIf="resumen.enProceso"> · {{ cantidad(resumen.enProceso) }} en proceso</ng-container>
      </span>
    </div>
    <div class="total">
      <span class="total-titulo">Ajustes manuales</span>
      <strong class="total-monto">{{ montoClp(resumen.ajustes.neto, true) }}</strong>
      <span class="total-pie">{{ cantidad(resumen.ajustes.cantidad) }} ajustes · neto</span>
    </div>
  </div>

  <!-- ═══ Resumen ═══ -->
  <div class="flex flex-wrap items-center justify-between gap-2 mb-2 px-1">
    <p class="text-sm text-gray-500 m-0">
      <ng-container *ngIf="!cargando">
        <strong class="text-gray-800">{{ cantidad(total) }}</strong>
        {{ total === 1 ? 'operación' : 'operaciones' }}
        <span *ngIf="total > 0"> · mostrando {{ primeraFila }}–{{ ultimaFila }}</span>
      </ng-container>
      <ng-container *ngIf="cargando">Buscando…</ng-container>
    </p>
    <label class="text-sm text-gray-500 flex items-center gap-2">
      <span class="hidden sm:inline">Filas</span>
      <select class="control control-mini" [ngModel]="limite"
        (ngModelChange)="cambiarLimite($event)">
        <option *ngFor="let n of opcionesLimite" [value]="n">{{ n }}</option>
      </select>
    </label>
  </div>

  <!-- ═══ Error ═══ -->
  <div *ngIf="error" class="aviso aviso-error mb-4">
    <mat-icon class="icono">error_outline</mat-icon>
    <p class="m-0">{{ error }}</p>
  </div>

  <!-- ═══ Cargando ═══ -->
  <div *ngIf="cargando" class="tarjeta p-6 text-center text-gray-400 text-sm">
    <mat-spinner diameter="28" class="mx-auto mb-3"></mat-spinner>
    Cargando operaciones…
  </div>

  <!-- ═══ Vacío ═══ -->
  <div *ngIf="!cargando && !error && filas.length === 0" class="tarjeta p-8 text-center">
    <mat-icon class="icono-vacio">search_off</mat-icon>
    <p class="font-semibold text-gray-700 mt-2 mb-1">No hay operaciones con esos filtros</p>
    <p class="text-sm text-gray-500 m-0">Probá ampliar el período o sacar algún filtro.</p>
    <button type="button" class="btn-secundario mt-4 mx-auto" (click)="limpiar()">
      Limpiar filtros
    </button>
  </div>

  <!-- ═══ Tabla (pantallas grandes) ═══ -->
  <div *ngIf="!cargando && filas.length" class="tarjeta hidden lg:block overflow-hidden">
    <div class="overflow-x-auto">
      <table class="tabla">
        <thead>
          <tr>
            <th class="w-40">Fecha</th>
            <th>Operación</th>
            <th>Riel</th>
            <th>Cliente</th>
            <th class="text-right">Origen</th>
            <th class="text-right">Destino</th>
            <th>Estado</th>
            <th class="w-10"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let fila of filas; trackBy: porFila">
            <tr class="fila" (click)="alternarDetalle(fila)"
              [class.fila-abierta]="expandida === llave(fila)">
              <td class="whitespace-nowrap text-gray-600">{{ fechaLegible(fila.fecha) }}</td>
              <td>
                <div class="font-semibold text-gray-800">{{ etiquetaGrupo(fila.grupo) }}</div>
                <div class="text-xs text-gray-400">{{ fila.tipo }}</div>
              </td>
              <td class="text-gray-600">{{ fila.rail || '—' }}</td>
              <td class="max-w-[16rem]">
                <div class="truncate text-gray-800">{{ fila.nombre || '—' }}</div>
                <div class="truncate text-xs text-gray-400">{{ fila.email }}</div>
              </td>
              <td class="text-right whitespace-nowrap text-gray-700">
                {{ monto(fila.monto_origen, fila.moneda_origen) }}
              </td>
              <td class="text-right whitespace-nowrap text-gray-700">
                {{ monto(fila.monto_destino, fila.moneda_destino) }}
              </td>
              <td><span class="chip" [ngClass]="claseEstado(fila.estado)">{{ fila.estado }}</span></td>
              <td class="text-gray-400">
                <mat-icon class="icono"
                  [style.transform]="expandida === llave(fila) ? 'rotate(180deg)' : 'rotate(0)'">
                  expand_more
                </mat-icon>
              </td>
            </tr>
            <tr *ngIf="expandida === llave(fila)" class="fila-detalle">
              <td colspan="8">
                <div class="grid grid-cols-2 xl:grid-cols-4 gap-x-6 gap-y-3">
                  <div class="dato"><span>ID</span><strong>{{ fila.fuente }} #{{ fila.id }}</strong></div>
                  <div class="dato"><span>Referencia</span><strong>{{ fila.referencia || '—' }}</strong></div>
                  <div class="dato"><span>Documento</span><strong>{{ fila.documento || '—' }}</strong></div>
                  <div class="dato"><span>ID usuario</span><strong>{{ fila.usuario_id || '—' }}</strong></div>
                  <div class="dato"><span>{{ etiquetaContraparte(fila) }}</span><strong>{{ fila.beneficiario || '—' }}</strong></div>
                  <div class="dato"><span>Banco</span><strong>{{ fila.banco || '—' }}</strong></div>
                  <div class="dato"><span>Cuenta</span><strong>{{ fila.cuenta || '—' }}</strong></div>
                  <div class="dato"><span>Tasa</span><strong>{{ tasaLegible(fila.tasa) }}</strong></div>
                  <div class="dato"><span>Creada</span><strong>{{ fechaLegible(fila.fecha_creacion) }}</strong></div>
                  <div class="dato"><span>Cerrada</span><strong>{{ fechaLegible(fila.fecha_termino) }}</strong></div>
                  <div class="dato"><span>Operador</span><strong>{{ fila.operador || '—' }}</strong></div>
                  <div class="dato" *ngIf="fila.vita_tracking_id">
                    <span>Vita</span><strong>{{ fila.vita_tracking_id }} · {{ fila.vita_status }}</strong>
                  </div>
                  <div class="dato col-span-2 xl:col-span-4" *ngIf="fila.motivo_rechazo">
                    <span>Motivo del rechazo</span><strong>{{ fila.motivo_rechazo }}</strong>
                  </div>
                </div>
                <div class="acciones">
                  <a *ngIf="fila.usuario_id && fila.email" class="btn-secundario"
                    [routerLink]="['/wallet/admin/user-balance', fila.usuario_id, fila.email]">
                    <mat-icon class="icono">person_search</mat-icon> Ver cliente
                  </a>
                  <button *ngIf="fila.referencia" type="button" class="btn-secundario"
                    (click)="copiar(fila.referencia, $event)">
                    <mat-icon class="icono">content_copy</mat-icon> Copiar referencia
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ═══ Tarjetas (celular y tablet) ═══ -->
  <div *ngIf="!cargando && filas.length" class="lg:hidden flex flex-col gap-2">
    <div *ngFor="let fila of filas; trackBy: porFila" class="tarjeta tarjeta-fila"
      (click)="alternarDetalle(fila)">
      <div class="flex items-start justify-between gap-3">
        <div class="min-w-0">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="font-bold text-sm text-gray-800">{{ etiquetaGrupo(fila.grupo) }}</span>
            <span class="chip" [ngClass]="claseEstado(fila.estado)">{{ fila.estado }}</span>
          </div>
          <div class="text-xs text-gray-400 mt-0.5">{{ fila.tipo }} · {{ fila.rail || '—' }}</div>
        </div>
        <div class="text-right shrink-0">
          <div class="text-xs text-gray-400">{{ diaLegible(fila.fecha) }}</div>
          <div class="text-[11px] text-gray-400">{{ horaLegible(fila.fecha) }}</div>
        </div>
      </div>

      <div class="mt-2 text-sm text-gray-700 truncate">{{ fila.nombre || '—' }}</div>
      <div class="text-xs text-gray-400 truncate">{{ fila.email }}</div>

      <div class="flex items-center justify-between gap-2 mt-2 pt-2 border-t border-gray-100">
        <span class="text-sm font-semibold text-gray-800">
          {{ monto(fila.monto_origen, fila.moneda_origen) }}
        </span>
        <mat-icon class="icono-mini text-gray-300">arrow_forward</mat-icon>
        <span class="text-sm font-semibold text-gray-800">
          {{ monto(fila.monto_destino, fila.moneda_destino) }}
        </span>
      </div>

      <div *ngIf="expandida === llave(fila)" class="mt-3 pt-3 border-t border-gray-100 grid grid-cols-2 gap-x-4 gap-y-2">
        <div class="dato"><span>ID</span><strong>{{ fila.fuente }} #{{ fila.id }}</strong></div>
        <div class="dato"><span>Documento</span><strong>{{ fila.documento || '—' }}</strong></div>
        <div class="dato"><span>Referencia</span><strong class="break-all">{{ fila.referencia || '—' }}</strong></div>
        <div class="dato"><span>{{ etiquetaContraparte(fila) }}</span><strong>{{ fila.beneficiario || '—' }}</strong></div>
        <div class="dato"><span>Banco</span><strong>{{ fila.banco || '—' }}</strong></div>
        <div class="dato"><span>Cuenta</span><strong class="break-all">{{ fila.cuenta || '—' }}</strong></div>
        <div class="dato"><span>Tasa</span><strong>{{ tasaLegible(fila.tasa) }}</strong></div>
        <div class="dato"><span>Operador</span><strong class="break-all">{{ fila.operador || '—' }}</strong></div>
        <div class="dato"><span>Creada</span><strong>{{ fechaLegible(fila.fecha_creacion) }}</strong></div>
        <div class="dato"><span>Cerrada</span><strong>{{ fechaLegible(fila.fecha_termino) }}</strong></div>
        <div class="dato col-span-2" *ngIf="fila.vita_tracking_id">
          <span>Vita</span><strong>{{ fila.vita_tracking_id }} · {{ fila.vita_status }}</strong>
        </div>
        <div class="dato col-span-2" *ngIf="fila.motivo_rechazo">
          <span>Motivo del rechazo</span><strong>{{ fila.motivo_rechazo }}</strong>
        </div>
        <div class="acciones col-span-2">
          <a *ngIf="fila.usuario_id && fila.email" class="btn-secundario"
            [routerLink]="['/wallet/admin/user-balance', fila.usuario_id, fila.email]"
            (click)="$event.stopPropagation()">
            <mat-icon class="icono">person_search</mat-icon> Ver cliente
          </a>
          <button *ngIf="fila.referencia" type="button" class="btn-secundario"
            (click)="copiar(fila.referencia, $event)">
            <mat-icon class="icono">content_copy</mat-icon> Copiar referencia
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ Paginado ═══ -->
  <div *ngIf="!cargando && totalPaginas > 1" class="paginado">
    <button type="button" class="btn-pag" [disabled]="pagina === 1" (click)="irAPagina(1)"
      aria-label="Primera página">
      <mat-icon class="icono">first_page</mat-icon>
    </button>
    <button type="button" class="btn-pag" [disabled]="pagina === 1" (click)="irAPagina(pagina - 1)"
      aria-label="Página anterior">
      <mat-icon class="icono">chevron_left</mat-icon>
    </button>

    <button *ngFor="let n of paginasVisibles" type="button" class="btn-pag btn-pag-num"
      [class.activa]="n === pagina" (click)="irAPagina(n)">{{ n }}</button>

    <button type="button" class="btn-pag" [disabled]="pagina === totalPaginas"
      (click)="irAPagina(pagina + 1)" aria-label="Página siguiente">
      <mat-icon class="icono">chevron_right</mat-icon>
    </button>
    <button type="button" class="btn-pag" [disabled]="pagina === totalPaginas"
      (click)="irAPagina(totalPaginas)" aria-label="Última página">
      <mat-icon class="icono">last_page</mat-icon>
    </button>

    <span class="text-xs text-gray-400 ml-2 whitespace-nowrap">
      {{ pagina }} / {{ totalPaginas }}
    </span>
  </div>
</div>
